import { useAppSelector } from 'reduxTyped'

import { BlocksConversionRules } from 'common/builder/components/chart/FlowChart/adapters/block.converter.rules'
import { GenericButtonConverterRules } from 'common/builder/components/chart/FlowChart/adapters/generic/buttons/converter.rules'
import { NodeConversionRules } from 'common/builder/components/chart/FlowChart/adapters/node.converter.rules'
import { predicateConverter } from 'common/builder/components/chart/FlowChart/lib/PredicateConverter'
import { NodeConverterRulePayload } from 'common/builder/components/chart/FlowChart/lib/types'
import { FlowChartTrigger } from 'common/builder/components/chart/FlowChart/types/FlowChartTrigger'
import builderSelectors from 'common/builder/selectors/builder'
import * as entitySelectors from 'common/builder/selectors/builder/entitySelectors'
import { getFlowPersonalizationFields } from 'common/builder/selectors/builder/fieldsSelectors'
import { getBotTimezone } from 'common/core/selectors/appSelectors'
import * as flowSelectors from 'common/flow/selectors/flowSelectors'

export const useFlowChartNodes = ({
  builderId,
  flowId,
  flowChartTriggers,
}: {
  builderId: string
  flowId: string
  flowChartTriggers: FlowChartTrigger[]
}) => {
  return useAppSelector((state) => {
    const blocks = entitySelectors.getBlocksMap(state, builderId)
    const buttonsMap = entitySelectors.getButtonsMap(state, builderId)
    const nodes = entitySelectors.getNodesList(state, builderId)
    const fields = getFlowPersonalizationFields(state, builderId)
    const { rootId: rootNodeId, flow } = builderSelectors.state.getById(state, builderId) || {}
    const isStatByJSONAdsTrigger = flowSelectors.isStatByJSONAdsTrigger(state, flow)
    const timezone = getBotTimezone(state)

    const flowChartButtons = predicateConverter.convertEntityMap({
      entities: buttonsMap,
      rules: GenericButtonConverterRules,
      payload: {
        state,
        fields,
        builderId,
      },
    })

    const flowChartBlocks = predicateConverter.convertEntityMap({
      entities: blocks,
      rules: BlocksConversionRules,
      payload: {
        state,
        fields,
        builderId,
        flowChartButtons,
      },
    })

    const nodeConverterPayload: NodeConverterRulePayload = {
      state,
      fields,
      builderId,
      rootNodeId,
      isStatByJSONAdsTrigger,
      blocks,
      flowChartBlocks,
      flowChartButtons,
      flowChartTriggers,
      timezone,
      flowId,
    }

    return predicateConverter.convertEntities({
      entities: nodes,
      rules: NodeConversionRules,
      payload: nodeConverterPayload,
    })
  })
}
